import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

export function ClassesIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path d="M17.844 5.804L13.2 9.183a4.003 4.003 0 0 1 2.794 3.573l1.144-.859a38.799 38.799 0 0 0 4.156-3.604 1.828 1.828 0 0 0 0-2.586 2.31 2.31 0 0 0-2.992-.235l-.457.332zM15.83 4.797l1.295-.942a4.31 4.31 0 0 1 5.583.438 3.828 3.828 0 0 1 0 5.414 40.799 40.799 0 0 1-4.37 3.79l-4.04 3.03c-.5.375-1.076.597-1.665.666a4.999 4.999 0 0 1-3.282-.299L2.148 13.62a2 2 0 0 1-.349-3.438L10.92 3.55a2 2 0 0 1 2.071-.172l2.838 1.42zm-1.822 1.325l-1.91-.956L2.976 11.8 8.17 14.16a4 4 0 0 1-.164-1.403 3.946 3.946 0 0 1 1.618-3.449l4.382-3.187zM12 11a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm0 3a1 1 0 1 1 0-2 1 1 0 0 1 0 2z" />
    </SvgIcon>
  );
}
